import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-cards";
import { EffectCards } from "swiper/modules";
import { useSelector, useDispatch } from "react-redux";
import {
  AddNewCertificate,
  AddNewService,
  EditServiceD,
  fetchAllData,
} from "../../../redux/slices/mainDataSlice";
import { toast } from "react-toastify";

export default function ServiceEdit({
  serviceEdit,
  serviceId,
  setServiceEdit,
}) {
  const [name, setName] = useState(``);
  const [desc, setDesc] = useState(``);
  const dispatch = useDispatch();
  const data = useSelector((state) => state.main.data?.servicesData)?.filter(
    (item) => item.id == serviceId
  )?.[0];
  const saveNewService = () => {
    dispatch(EditServiceD({ name, desc, id: serviceId }));
    setDesc("");
    setName("");
    toast.info("Editing Service...", { autoClose: false });
    setServiceEdit(false);
  };

  return (
    serviceEdit && (
      <div className="service-edit-action" data-aos="fade-in">
        <div
          className="content-layout"
          onClick={() => setServiceEdit(false)}
        ></div>
        <div className="container ">
          <div className="title">تعديل خدمه </div>

          <div className="text">
            <input
              type="text"
              placeholder="Name"
              defaultValue={data?.service_card_name}
              onChange={(e) => setName(e.target.value)}
            />
            <textarea
              type="text"
              placeholder="Description"
              defaultValue={data?.service_card_info}
              onChange={(e) => setDesc(e.target.value)}
            />
          </div>
          <div className="add-btn" onClick={() => saveNewService()}>
            تعديل
          </div>
        </div>
      </div>
    )
  );
}
